import { render, staticRenderFns } from "./joinStep.vue?vue&type=template&id=cd73358c&scoped=true&"
import script from "./joinStep.vue?vue&type=script&lang=js&"
export * from "./joinStep.vue?vue&type=script&lang=js&"
import style0 from "./joinStep.vue?vue&type=style&index=0&id=cd73358c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd73358c",
  null
  
)

export default component.exports